<template>
  <nav class="nav-footer">
    <FooterLink
      v-for="link of currentLinks"
      :key="link.title"
      :title="link.title"
      :label="link.label"
      :param="link.param"
    />
  </nav>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import FooterLink from "./FooterLink.vue";

const props = defineProps({
  currentPage: String,
  allLinks: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();

const currentLinks = computed(() => {
  const currentPageIndex = props.allLinks.indexOf(props.currentPage);
  const prevPage = props.allLinks[currentPageIndex - 1];
  const nextPage = props.allLinks[currentPageIndex + 1];

  return [
    {
      param: prevPage,
      title: t("footer.navLabels.prev"),
      label: t(`navigation.${prevPage}`),
    },
    // TODO: Other label for hub multimediale
    {
      param: nextPage,
      title: t("footer.navLabels.next"),
      label: t(`navigation.${nextPage}`),
    },
  ];
});
</script>

<style lang="scss" scoped>
.nav-footer {
  background-color: var(--black-100);
  border-bottom: 1px solid var(--white-100);
  display: flex;

  .desktop &,
  .large & {
    padding: 1.5rem var(--page-padding-h);
  }

  .mobile &,
  .tablet & {
    flex-direction: column;
  }
}
</style>
